import a from "./index.es43.js";
function u(o, t) {
  const p = {
    status: t ? "draft" : "published",
    filters: {
      slug: {
        $eq: o
      }
    },
    populate: {
      distributionExplanation: {
        populate: "*"
      },
      // components: {
      //   populate: {
      //     tooltips: {
      //       populate: '*',
      //     },
      //     accordions: {
      //       populate: '*',
      //     },
      //   },
      // },
      components: {
        on: {
          "common.text-block": {
            populate: "*"
          },
          "common.accordions-block": {
            populate: "*"
          }
        }
      },
      indicatorGroups: {
        populate: {
          indicators: {
            populate: {
              indicator: {
                populate: {
                  file: {
                    populate: "*"
                  },
                  about: {
                    populate: "*"
                  },
                  explanation: {
                    populate: "*"
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  return a.stringify(p);
}
export {
  u as default
};
//# sourceMappingURL=index.es10.js.map
